// extracted by mini-css-extract-plugin
module.exports = {"Container":"Checkbox_Container__1O37J","Checked":"Checkbox_Checked__2bjzg"};